export default {
  errors: {
    wrong_brn_format: "หมายเลข BRN ไม่ถูกต้อง",
    db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
    db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
    permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
    // สะกดตามคีย์ที่ backend ส่งมาจริง (WPMLHGV4, WPSubscriberV4) ซึ่งพิมพ์ตก d
    // เช่นเดียวกับ errors.mlhg.access_denie ที่มีอยู่เดิม ห้ามแก้เป็น access_denied
    // จนกว่า backend จะเปลี่ยนคีย์
    access_denie: "ผู้ใช้งานไม่มีสิทธิ์ในการเข้าถึงข้อมูลนี้",
    eas: {
      required: "กรุณาเลือก EAS Server",
      not_configured: "EAS Server ไม่ได้ตั้งค่าไว้",
      enterprise_unbound: "องค์กรนี้ยังไม่ได้ผูก EAS Server",
      capacity_full: "EAS Server ที่เลือกเต็มแล้ว"
    },
    easmigration: {
      invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
      preflight_blocked: "องค์กรนี้ยังไม่สามารถย้าย EAS Server ได้",
      enterprise_not_found: "ไม่พบข้อมูลองค์กร",
      not_main_branch:
        "ย้ายได้เฉพาะองค์กรหลักเท่านั้น กรุณาเลือกองค์กรหลักของสาขานี้",
      same_eas: "EAS Server ปลายทางเป็นเครื่องเดียวกับต้นทาง",
      in_progress: "องค์กรนี้มีรายการย้าย EAS Server ที่ยังไม่เสร็จสิ้น",
      target_capacity_full: "EAS Server ปลายทางมีพื้นที่ไม่พอสำหรับทั้งองค์กร",
      sub_branches_included: "สาขาย่อยขององค์กรนี้จะถูกย้ายไปด้วย",
      // เป็นเงื่อนไขที่บล็อกการย้าย ไม่ใช่คำเตือน เพราะระบบจะทำงานกับทุกรายการ
      // บน EAS Server ของกลุ่มองค์กรเพียงเครื่องเดียว หมายเลขที่บันทึกไว้คนละเครื่อง
      // จะหาไม่พบระหว่างการย้าย และงานจะล้มเหลวกลางคัน หลังจากที่ย้ายหมายเลขอื่นไปแล้ว
      number_eas_mismatch:
        "มีหมายเลขที่บันทึก EAS Server ไม่ตรงกับขององค์กร กรุณาแก้ไขก่อนเริ่มการย้าย",
      // target_sipserver_missing ถูกกำหนดไว้ด้านล่างรวมกับคีย์ที่ระบบเบื้องหลังเขียน
      // เพราะเป็นเงื่อนไขเดียวกัน เพียงแต่ pre-flight ตรวจพบก่อน
      // หมายเลข Pilot ของ Hunt Group ถูกบันทึกในรูปแบบที่ระบบไม่สามารถแปลง
      // เป็นชื่อที่ MetaSwitch รู้จักได้
      dummy_pilot_identity:
        "หมายเลข Pilot ของ Hunt Group ถูกบันทึกในรูปแบบที่ไม่ถูกต้อง จึงไม่สามารถย้ายได้",
      // หมายเลขในตาราง number ถูกบันทึกในรูปแบบที่ระบบไม่สามารถแปลงเป็นชื่อที่
      // MetaSwitch รู้จักได้ (เช่น หมายเลขสั้นที่ไม่มี charge number ที่ใช้ได้)
      number_identity:
        "มีหมายเลขที่ถูกบันทึกในรูปแบบที่ไม่ถูกต้อง จึงไม่สามารถระบุข้อมูลบน MetaSwitch เพื่อย้ายได้",
      voicemail_destroyed:
        "ข้อความ Voicemail ที่เก็บอยู่บน EAS Server ปัจจุบันจะถูกลบอย่างถาวร",
      // ---- issue #34: start endpoint + background worker ----
      // ผู้ใช้งานต้องยืนยันก่อนเริ่มย้าย เพราะข้อความ Voicemail บน EAS ต้นทาง
      // จะถูกลบและไม่สามารถกู้คืนได้
      voicemail_not_confirmed:
        "กรุณายืนยันว่ารับทราบว่าข้อความ Voicemail จะถูกลบอย่างถาวร ก่อนเริ่มการย้าย",
      not_found: "ไม่พบรายการย้าย EAS Server",
      start_failed: "ไม่สามารถเริ่มการย้าย EAS Server ได้",
      // ---- issue #41: แยกขั้นตอน "อ่านข้อมูล" ออกจาก "ย้ายข้อมูล" ----
      // กด "ย้ายข้อมูล" กับรายการที่ยังไม่ได้อ่านข้อมูลจนสำเร็จ
      // การอ่านข้อมูลไม่ลบอะไรทั้งสิ้น จึงต้องทำให้ผ่านก่อนเสมอ
      read_required:
        "ต้องอ่านข้อมูลขององค์กรนี้ให้สำเร็จก่อน จึงจะเริ่มการย้ายได้",
      // เตือนเฉย ๆ ไม่ได้ห้าม: ระบบจะตรวจความจุและสถานะของทุกออบเจ็กต์
      // บน EAS Server ทั้งสองเครื่องอีกครั้งก่อนลงมือจริงอยู่แล้ว
      read_stale:
        "ข้อมูลที่อ่านไว้ถูกอ่านมานานแล้ว อาจไม่ตรงกับสถานะปัจจุบัน แนะนำให้อ่านข้อมูลใหม่ก่อนยืนยันการย้าย",
      // ค่าเหล่านี้ถูกบันทึกลง eas_migration.error_log /
      // eas_migration_item.error_log ในรูปแบบ "errors.<key>|<รายละเอียด>"
      // หน้าจอจะแสดงข้อความนี้แล้วต่อท้ายด้วยรายละเอียดหลังเครื่องหมาย |
      source_changed:
        "องค์กรนี้ถูกย้ายไป EAS Server อื่นหลังจากที่สร้างรายการย้ายนี้แล้ว",
      snapshot_failed: "ไม่สามารถอ่านข้อมูลปัจจุบันจาก MetaSwitch ได้",
      snapshot_missing: "ไม่มีข้อมูลสำรองของรายการนี้",
      eas_pass_unavailable:
        "ไม่สามารถอ่านรหัสผ่าน EAS ของหมายเลขนี้ได้ จึงไม่สามารถสร้างใหม่โดยไม่เปลี่ยนรหัสผ่าน",
      // อ่านรหัส PIN ของ Voicemail จากข้อมูลสำรองไม่ได้ ถ้าสร้างใหม่โดยใช้ PIN
      // ที่ระบบสุ่มหรือค่าเริ่มต้น รหัสเดิมของผู้ใช้จะถูกเปลี่ยนโดยไม่มีทางกู้คืน
      // เพราะข้อมูลต้นทางจะถูกลบในขั้นตอนถัดไป
      eas_pin_unavailable:
        "ไม่สามารถอ่านรหัส PIN ของ Voicemail ของหมายเลขนี้ได้ จึงไม่สามารถสร้างใหม่โดยไม่เปลี่ยนรหัส PIN",
      item_list_invalid: "รายการที่ต้องย้ายไม่ครบถ้วน",
      bg_create_failed: "ไม่สามารถสร้าง Business Group บน EAS Server ปลายทางได้",
      source_object_missing: "ไม่สามารถอ่านรายการนี้จาก EAS Server ต้นทางได้",
      eas_delete_failed: "ไม่สามารถลบรายการนี้ออกจาก EAS Server ต้นทางได้",
      eas_create_failed: "ไม่สามารถสร้างรายการนี้บน EAS Server ปลายทางได้",
      cfs_repoint_failed:
        "ไม่สามารถอัปเดต Termination ให้ชี้ไปยัง EAS Server ปลายทางได้",
      items_unfinished:
        "มีบางรายการย้ายไม่สำเร็จ จึงยังไม่ลบ Business Group ออกจาก EAS Server ต้นทาง",
      bg_delete_failed:
        "ไม่สามารถลบ Business Group ออกจาก EAS Server ต้นทางได้",
      bg_delete_not_confirmed:
        "สั่งลบ Business Group แล้ว แต่ตรวจสอบซ้ำหลายครั้งยังพบว่ายังอยู่บน EAS Server ต้นทาง ระบบหยุดไว้เพื่อไม่ให้เกิด Business Group ชื่อเดียวกันอยู่สองเครื่องพร้อมกัน กรุณาตรวจสอบบน MetaSwitch แล้วกด Retry",
      verify_failed: "ตรวจสอบผลหลังการย้ายไม่ผ่าน",
      // EAS Server ปลายทางยังไม่ได้ตั้งค่า SIP Server ใน config.yml
      // หากย้ายต่อ เส้นทางการโทรจะยังชี้ไป EAS Server ต้นทางโดยที่ระบบแจ้งว่าสำเร็จ
      target_sipserver_missing:
        "EAS Server ปลายทางยังไม่ได้ตั้งค่า SIP Server จึงไม่สามารถย้ายเส้นทางการโทรได้",
      // อ่านประเภทบัญชี EAS ของหมายเลข MAIN_IVR ไม่ได้
      // หากสร้างใหม่โดยไม่มีค่านี้ บัญชีผู้ดูแลองค์กรจะกลายเป็นหมายเลขทั่วไป
      account_type_missing:
        "ไม่สามารถอ่านประเภทบัญชีของหมายเลขนี้ได้ หากสร้างใหม่บัญชีผู้ดูแลองค์กรจะกลายเป็นหมายเลขทั่วไป",
      // ตรวจสอบสถานะของออบเจ็กต์บน EAS Server ไม่ได้ (ทั้งต้นทางและปลายทาง
      // ตอบกลับด้วยรหัสที่ไม่ใช่ "ไม่พบข้อมูล") ระบบยังไม่ได้ส่งคำสั่งใด ๆ
      // จึงไม่มีข้อมูลถูกแก้ไข ผู้ใช้งานแก้ที่ต้นเหตุแล้วเริ่มใหม่ได้ทันที
      object_state_unknown:
        "ไม่สามารถตรวจสอบสถานะของรายการนี้บน EAS Server ได้ ระบบจึงหยุดไว้โดยยังไม่ได้แก้ไขข้อมูลใด ๆ กรุณาตรวจสอบการเชื่อมต่อกับ MetaSwitch แล้วทำรายการใหม่อีกครั้ง",
      // พบออบเจ็กต์เดียวกันอยู่บน EAS Server สองเครื่องพร้อมกัน เกิดจากการย้าย
      // ครั้งก่อนสร้างที่ปลายทางสำเร็จแต่ลบที่ต้นทางไม่สำเร็จ ระบบไม่เดาว่า
      // ควรลบเครื่องไหน เพราะลบผิดเครื่องแล้วกู้คืนไม่ได้
      object_on_both_eas:
        "พบรายการนี้อยู่บน EAS Server ทั้งต้นทางและปลายทางพร้อมกัน ระบบไม่สามารถระบุได้ว่าสายใช้งานอยู่บนเครื่องใด จึงหยุดไว้โดยไม่ลบสิ่งใด กรุณาตรวจสอบว่าหมายเลขนี้ลงทะเบียนอยู่กับเครื่องใด ลบรายการที่ไม่ได้ใช้งานออกด้วยตนเอง แล้วเริ่มการย้ายใหม่",
      // ลำดับใหม่คือลบออกจากต้นทางให้ครบก่อนแล้วจึงเริ่มสร้างบนปลายทาง
      // เมื่อถึงช่วงสร้างแล้วยังพบรายการค้างอยู่บนต้นทาง แปลว่าคำสั่งลบไม่ผ่าน
      // หรือมีการสร้างรายการนี้ขึ้นใหม่ระหว่างที่งานกำลังทำงานอยู่ ถ้าสร้างต่อไป
      // รายการเดียวกันจะอยู่บนสองเครื่องพร้อมกัน ซึ่งเป็นสิ่งที่ห้ามเด็ดขาด
      object_still_on_source:
        "รายการนี้ยังค้างอยู่บน EAS Server ต้นทางเมื่อถึงขั้นตอนสร้างบนเครื่องปลายทาง ซึ่งตามลำดับการทำงานต้องถูกลบไปก่อนหน้านี้แล้ว ระบบจึงหยุดไว้โดยไม่สร้างสิ่งใด เพราะจะทำให้รายการเดียวกันอยู่บน EAS Server สองเครื่องพร้อมกัน กรุณาตรวจสอบรายการนี้บนเครื่องต้นทาง แล้วกด “ทำต่อจากที่ค้างไว้” อีกครั้ง",
      // เหมือน object_still_on_source แต่เป็นระดับ Business Group และเกิดในจังหวะ
      // ที่แย่ที่สุดของงาน: ขั้นตอนก่อนหน้าลบทุกหมายเลขและ Business Group ออกจาก
      // เครื่องต้นทางไปครบแล้ว องค์กรจึงไม่ได้อยู่บน EAS Server เครื่องใดเลย
      // ข้อความนี้ต้องบอกทั้ง "ทำอะไรต่อ" และ "ตอนนี้องค์กรใช้งานไม่ได้อยู่"
      // ไม่ใช่แค่รายงานว่าล้มเหลว
      bg_still_on_source:
        "Business Group ขององค์กรนี้ยังค้างอยู่บน EAS Server ต้นทางเมื่อถึงขั้นตอนสร้างบนเครื่องปลายทาง ซึ่งตามลำดับการทำงานต้องถูกลบไปก่อนหน้านี้แล้ว ระบบจึงหยุดไว้โดยยังไม่สร้างสิ่งใด เพราะ Business Group ชื่อเดียวกันอยู่บน EAS Server สองเครื่องพร้อมกันไม่ได้ ขณะนี้หมายเลขทั้งหมดขององค์กรถูกลบออกจากเครื่องต้นทางแล้วและยังใช้งานไม่ได้จนกว่าการสร้างบนเครื่องปลายทางจะเสร็จ กรุณาตรวจสอบว่า Business Group นี้เหลืออยู่บนเครื่องใด ลบชุดที่ค้างอยู่บนเครื่องต้นทางออกด้วยตนเอง แล้วกด “ทำต่อจากที่ค้างไว้” อีกครั้ง",
      // โพรเซสที่รันงานนี้ถูกปิดกลางคัน (รีสตาร์ท ดีพลอย หรือถูก OOM kill)
      // ซึ่งตัวดักจับข้อผิดพลาดในโปรแกรมจับไม่ได้ งานจึงถูกกวาดเป็นล้มเหลว
      // เพื่อให้เริ่มใหม่ได้ ไม่ใช่ค้างอยู่ในสถานะกำลังทำงานตลอดไป
      worker_interrupted:
        "ระบบเบื้องหลังถูกปิดขณะที่รายการนี้กำลังทำงาน เช่น มีการรีสตาร์ทหรือติดตั้งเวอร์ชันใหม่ รายการจึงถูกบันทึกเป็นล้มเหลว สามารถเริ่มใหม่ได้ โดยระบบจะตรวจสอบสถานะของทุกรายการบน EAS Server ทั้งสองเครื่องก่อนดำเนินการเสมอ",
      // ระบบเบื้องหลังหยุดทำงานผิดปกติ รายการถูกบันทึกเป็นล้มเหลวเพื่อให้ลองใหม่ได้
      worker_panic: "การย้ายหยุดทำงานผิดปกติ สามารถลองใหม่ได้",
      // ---- สองขั้นตอนของหมายเลขภายใน (Extension) ----
      //
      // delete_extension เป็นขั้นตอนแรกของช่วงลบ และเป็นสิ่งแรกของงานทั้งหมดที่
      // เขียนลง MetaSwitch หากล้มเหลวจึงแปลว่ายังไม่มีอะไรถูกเปลี่ยนแปลงเลย
      // ครอบคลุมทั้งกรณีอ่านรายการไม่ได้ (ซึ่งไม่ถือว่า "ไม่มีรายการ") และกรณี
      // ส่งคำสั่งลบไม่สำเร็จ ทั้งสองกรณีรายการหมายเลขภายในยังอยู่บนต้นทางและ
      // ทุกหมายเลขยังใช้งานได้ ข้อความจึงต้องบอกให้ชัด เพื่อไม่ให้ผู้ปฏิบัติงาน
      // ไปตามหาความเสียหายที่ไม่ได้เกิดขึ้น
      extension_delete_failed:
        "ไม่สามารถลบรายการหมายเลขภายใน (Intercom Code) ของ Business Group ต้นทางได้ ระบบจึงหยุดไว้ก่อนที่จะลบสิ่งใด องค์กรยังไม่ถูกแตะต้องและยังใช้งานได้ตามปกติ กรุณาแก้ไขสาเหตุแล้วเริ่มการย้ายใหม่อีกครั้ง",
      // create_extension เป็นขั้นตอนสุดท้ายของช่วงสร้าง เมื่อมาถึงขั้นนี้หมายเลข
      // ทั้งหมดถูกย้ายไปแล้ว รายการที่เขียนกลับไม่สำเร็จเหลืออยู่เพียงในข้อมูล
      // สำรองของรายการย้ายนี้เท่านั้น ไม่ได้อยู่บน EAS Server เครื่องใด จึงต้อง
      // สั่งให้ "ทำต่อ" ไม่ใช่ให้อ่านข้อมูลองค์กรใหม่ ซึ่งจะได้เพียงรายการว่าง
      extension_restore_failed:
        "ไม่สามารถเขียนรายการหมายเลขภายใน (Intercom Code) กลับคืนไปยัง Business Group ได้ หมายเลขทั้งหมดถูกย้ายไปยัง EAS Server ปลายทางเรียบร้อยแล้ว แต่องค์กรยังโทรถึงกันด้วยหมายเลขภายในไม่ได้ และรายการนี้เหลืออยู่เพียงในข้อมูลสำรองของรายการย้ายนี้เท่านั้น กรุณากด “ทำต่อจากที่ค้างไว้” จนกว่าจะสำเร็จ"
    },
    // msw: "การเชื่อมต่อ MSw API ล้มเหลว",
    msw_unknown_result: "ไม่สามารถอ่านข้อมูลจาก MSw API",
    invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
    // backend ส่งทั้ง invalid_param และ invalid_parameter ปนกัน
    // (WPMLHGV4, WPPackage, WPCorporate) จึงต้องมีทั้งสองคีย์
    invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
    // ทุกปุ่มส่งออก xlsx ของ v4 ใช้คีย์นี้เมื่อสร้างไฟล์ไม่สำเร็จ
    // รายละเอียดของสาเหตุอยู่ใน Cause ซึ่ง modal แสดงแยกอยู่แล้ว
    export_failed:
      "ไม่สามารถสร้างไฟล์สำหรับดาวน์โหลดได้ กรุณาลองใหม่อีกครั้ง หากยังไม่สำเร็จ กรุณาใช้ตัวกรองเพื่อลดจำนวนข้อมูลที่ต้องการส่งออก",
    invalid_date: "ข้อมูลวันที่ไม่ถูกต้อง",
    invalid_date_range:
      "ข้อมูลช่วงวันที่ไม่ถูกต้อง กรุณาเลือกช่วงวันที่ไม่เกิน 31 วัน",
    invalid_date_range_over_60: "ช่วงเวลาที่เลือกเกิน 60 วัน",
    invalid_date_range_over_90: "ช่วงเวลาที่เลือกเกิน 90 วัน",
    invalid_keyword_number: "ข้อมูลหมายเลขไม่ถูกต้อง",
    twofa_code: "OTP ผิดพลาด ({0})",
    twofa: {
      S_AUT_00000: "OTP ผิดพลาด (S_AUT_00000)",
      B_AUT_00001: "User name หรือ Password ไม่ถูกต้อง",
      B_AUT_00002: "Password ไม่ถูกต้อง",
      B_AUT_00402: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_00403: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_00404: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00103: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00405: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00503:
        "ขณะนี้ระบบกำลังอยู่ระหว่างการปิดปรับปรุง รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00901: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00902: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00403: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00404: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00406: "เบอร์สำหรับรับ OTP ไม่ถูกต้อง",
      B_SRV_00410: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61001: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61002: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61003: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61004: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61005: "เบอร์รับ OTP ถูกระงับการใช้บริการ",
      B_SRV_61006: "เบอร์สำหรับรับ OTP ไม่ถูกต้อง",
      B_SRV_61007: "ระบบถูกล็อค กรุณาทำรายการใหม่ในอีก 15 นาทีถัดไป",
      B_SRV_61009: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61010: "รหัส OTP หมดอายุ กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61011: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61012: "ใส่ OTP ผิดเกิน 3 ครั้ง",
      B_SRV_61013: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00103: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00405: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00503:
        "ขณะนี้ระบบกำลังอยู่ระหว่างการปิดปรับปรุง รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00901: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00902: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00904: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00905: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00906: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00907: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00908: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00909: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00910: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13001: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13003: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13004: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13005: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13006: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13002: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13000: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00401: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00498: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00502: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ"
    },
    msw: {
      numberblock_add_failed: "เพิ่ม Number Block ไม่ได้",
      number_create_failed:
        "ไม่สามารถสร้างหรือเพิ่มหมายเลขโทรศัพท์นี้ในระบบได้",
      number_delete_failed: "ไม่สามารถลบหมายเลขโทรศัพท์นี้ออกจากระบบได้",
      delete_pirot_dummy_failed: "ไม่สามารถลบหมายเลขนำหมู่ออกจากระบบได้",
      voicemail_failed: "ไม่สามารถประมวลผลข้อมูลข้อความเสียง"
    },
    // ---- สำรอง Voicemail ก่อนย้าย EAS Server ----
    //
    // ชื่อ namespace คือ `voicemailbackup` คำเดียวติดกัน ตามที่ฝั่ง Go สะกดไว้จริง
    // ทุกคีย์ด้านล่างดึงมาจากซอร์ส backend โดยตรง ไม่ได้ตกลงกันไว้ล่วงหน้า
    //
    //   grep -rhoE '"(errors\.)?voicemailbackup[a-zA-Z0-9_.]*"' controllers/
    //
    // คีย์ส่วนใหญ่ในบล็อกนี้ถูกส่งกลับมาเป็น Msg และแปลผ่าน getErrorText()
    // ส่วนสี่คีย์สุดท้ายไม่เคยถูกส่งเป็น Msg เลย ระบบเบื้องหลังเขียนลงใน ErrorLog
    // ในรูปแบบ `key|รายละเอียด` (#24) หน้าจอจึงตัดที่เครื่องหมาย | แล้วแปลเฉพาะฝั่งซ้าย
    // ถ้าขาดคีย์ใดไป ผู้ปฏิบัติงานจะเห็น path ดิบบนหน้าจอแทนข้อความ
    voicemailbackup: {
      // --- ส่งกลับมาเป็น Msg ---
      invalid_parameter: "คำขอไม่มีรหัสรายการที่ถูกต้อง",
      not_found: "ไม่พบรายการสำรองข้อความเสียงนี้",
      enterprise_not_found: "ไม่พบข้อมูลองค์กร",
      in_progress: "องค์กรนี้มีรายการสำรองข้อความเสียงที่รออยู่หรือกำลังทำงานอยู่แล้ว",
      start_failed: "ไม่สามารถเริ่มการสำรองข้อความเสียงได้",
      not_ready: "รายการสำรองนี้ยังทำงานไม่เสร็จ จึงยังดาวน์โหลดไม่ได้",
      // ฝั่งกู้คืน not_a_backup กันสิ่งเดียวที่หน้าประวัติต้องไม่ปล่อยผ่าน
      // คือการสั่งกู้คืนจากงานกู้คืน ซึ่งไม่มีไฟล์สำรองของตัวเองให้กู้คืน
      not_a_backup: "รายการที่เลือกเป็นงานกู้คืน ไม่ใช่งานสำรองข้อมูล จึงไม่มีไฟล์สำรองให้กู้คืน",
      extract_failed: "ไม่สามารถแตกไฟล์สำรองได้",
      no_archive_entries: "ไม่พบข้อความเสียงในไฟล์สำรองนี้ จึงไม่มีอะไรให้กู้คืน",
      // MetaSwitch ตอบ SUCCESS แต่ไม่ได้ส่ง messaging repository กลับมาเลย
      // ไม่ใช่กล่องข้อความว่าง เพราะกล่องว่างยังคงส่ง repository กลับมาด้วย
      no_repository:
        "MetaSwitch ตอบว่าสำเร็จ แต่ไม่ได้ส่งข้อมูลข้อความเสียงของหมายเลขนี้กลับมา จึงไม่มีอะไรถูกเก็บลงไฟล์สำรอง กรณีนี้ไม่ใช่กล่องข้อความว่าง กรุณาตรวจสอบว่าหมายเลขนี้มีอยู่จริงบนเครื่องก่อนถือว่าไฟล์สำรองครบถ้วน",
      restore_failed: "ไม่สามารถกู้คืนข้อความเสียงได้",
      file_missing:
        "ไม่มีไฟล์สำรองอยู่บนเซิร์ฟเวอร์แล้ว ไฟล์ถูกลบไปหรือถูกล้างตามรอบเก็บรักษาข้อมูล กรุณาสำรองข้อมูลใหม่อีกครั้ง",
      storage_failed: "ไม่สามารถเขียนไฟล์สำรองลงเซิร์ฟเวอร์ได้",
      compress_failed: "ไม่สามารถบีบอัดไฟล์สำรองได้",
      no_numbers: "องค์กรนี้ไม่มีหมายเลขให้สำรองข้อมูล",
      download_interrupted: "การดาวน์โหลดหยุดลงก่อนที่ไฟล์จะถูกส่งครบ",
      // --- กู้คืนจากไฟล์ที่อัปโหลดกลับเข้ามา ---
      // API ทำงานอยู่สองเครื่องหลัง nginx โดยไม่มีดิสก์ร่วมกัน
      // ไฟล์สำรองอยู่บนดิสก์ของเครื่องที่สร้างมันเท่านั้น และถูกล้างตามรอบเก็บรักษา
      // ไฟล์ที่ผู้ปฏิบัติงานดาวน์โหลดเก็บไว้เองจึงเป็นต้นฉบับที่ใช้กู้คืนได้จริง
      upload_missing_file:
        "คำขอนี้ไม่มีไฟล์สำรองแนบมา หรือไฟล์ที่แนบมาไม่มีข้อมูล กรุณาเลือกไฟล์ ZIP ที่ดาวน์โหลดเก็บไว้แล้วอัปโหลดใหม่อีกครั้ง",
      upload_too_large:
        "ไฟล์สำรองที่อัปโหลดมีขนาดใหญ่เกินกว่าที่เซิร์ฟเวอร์รับได้ ระบบจึงยังไม่ได้เริ่มกู้คืน",
      upload_not_zip:
        "ไฟล์ที่อัปโหลดไม่ใช่ไฟล์ ZIP ที่เปิดอ่านได้ กรุณาตรวจสอบว่าเป็นไฟล์สำรองที่ดาวน์โหลดจากหน้านี้ และดาวน์โหลดมาครบถ้วน",
      // การกู้คืนข้อความเสียงขององค์กรหนึ่ง เข้ากล่องข้อความของอีกองค์กร
      // คือความผิดที่ย้อนกลับไม่ได้ คีย์นี้ใช้สองที่: เป็น Msg ตอนปฏิเสธไฟล์
      // ทั้งไฟล์ตอนอัปโหลด และเป็นคำนำหน้า Detail รายหมายเลขใน restoreOne
      // (ทั้งทางอัปโหลดและทาง /restore/start) ข้อความจึงต้องจริงกับ "หนึ่งหมายเลข
      // ในตารางที่แถวข้าง ๆ เป็น ok" ด้วย ห้ามเขียนว่า "ไม่มีอะไรถูกกู้คืนเลย"
      upload_wrong_enterprise:
        "หมายเลขในไฟล์สำรองไม่ใช่หมายเลขขององค์กรที่กำลังกู้คืน ระบบจึงไม่ได้กู้คืนหมายเลขที่ไม่ตรงกัน กรุณาตรวจสอบว่าไฟล์สำรองเป็นขององค์กรนี้จริง",
      // ไฟล์อยู่บนดิสก์ของเครื่องที่รับอัปโหลด ไม่มีการคัดลอกข้ามเครื่อง
      // จึงแก้ได้ทางเดียวคืออัปโหลดใหม่ ไม่ใช่การสั่งกู้คืนซ้ำ
      upload_unreachable:
        "ไฟล์ที่อัปโหลดถูกรับไว้ที่เซิร์ฟเวอร์อีกเครื่องหนึ่ง เครื่องที่ทำงานนี้จึงมองไม่เห็นไฟล์ และยังไม่ได้กู้คืนข้อมูลใด ๆ กรุณาอัปโหลดไฟล์สำรองใหม่อีกครั้ง",
      // --- แนบมาใน ErrorLog ในรูปแบบ `key|รายละเอียด` ---
      read_failed: "ไม่สามารถอ่านข้อความเสียงจาก EAS Server ได้",
      // คีย์เดียวใช้ทั้งสองฝั่ง: errorSummary() ใน Go worker อยู่บน struct
      // ที่ backup และ restore ใช้ร่วมกัน ข้อความตรงนี้จึงต้องจริงกับทั้งสองฝั่ง
      // ฝั่ง frontend จะ remap ตาม Kind (vmErrorKeyForKind) ไปยังข้อความเฉพาะ
      // ในบล็อก voicemaillog ส่วนบรรทัดนี้คือค่าตั้งต้นเมื่อไม่รู้ Kind
      partial: "มีบางหมายเลขที่ทำรายการไม่สำเร็จ",
      worker_interrupted:
        "ระบบเบื้องหลังที่ทำรายการนี้หยุดทำงานก่อนที่จะสำรองเสร็จ กรุณาสำรองข้อมูลใหม่อีกครั้ง",
      expired: "ไฟล์สำรองถูกล้างไปแล้วตามรอบเก็บรักษาข้อมูล"
    },
    dtac: {
      idcard_validate_fail: "ไม่พบข้อมูล BRN นี้",
      subs_query_status_failed:
        "ไม่พบข้อมูลของหมายเลขโทรศัพท์นี้ในระบบของดีแทค",
      subs_query_package_failed: "ไม่พบข้อมูลของแพ็กเกจนี้ในระบบของดีแทค",
      wci_failed: "ไม่สามารถสร้างหรือเพิ่มหมายเลขโทรศัพท์นี้ได้",
      unknown_result: "ไม่สามารถอ่านข้อมูลจาก DTAC API",
      wci_queue: "การสร้างหมายเลขอยู่ในคิว"
    },
    user: {
      duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
      blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
      fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
      enterprise_empty: "กรุณาระบุองค์กร",
      name_empty: "กรุณาชื่อผู้ใช้งาน",
      phone_wrong_format: "หมายเลขโทรศัพท์ไม่ถูกต้อง"
    },
    corp: {
      wrong_type: "ประเภทองค์กรไม่ถูกต้อง",
      wrong_format: "รูปแบบชื่อองค์กรไม่ถูกต้อง",
      duplicate: "ข้อมูลองค์กรซ้ำ",
      not_exist: "ไม่พบข้อมูลองค์กร",
      check_number_fail: "การตรวจสอบหมายเลขผิดพลาด",
      check_user_fail: "การตรวจสอบผู้ใช้งานผิดพลาด",
      number_exist: "มีหมายเลขที่ใช้งานอยู่ในองค์กร",
      failed: "การปรับปรุงข้อมูลองค์กรผิดพลาด",
      create_failed: "สร้างข้อมูลองค์กรผิดพลาด",
      delete_failed: "ลบข้อมูลองค์กรผิดพลาด",
      user_exist: "มีผู้ใช้งานอยู่ในองค์กร",
      is_not_main_branch: "องค์กรไม่ใช่สาขาหลัก"
    },
    mlhg: {
      duplicate: "ข้อมูลกลุ่ม Hunt ซ้ำ",
      get_dummy_number_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
      not_exist: "ไม่พบข้อมูลกลุ่ม Hunt",
      member_not_exist: "ไม่พบข้อมูลหมายเลขในกลุ่ม Hunt",
      member_not_in_corp: "ไม่มีหมายเลขนี้ในองค์กร",
      get_enterprise_fail: "ไม่พบข้อมูลองค์กร",
      get_mlhg_fail: "ไม่พบข้อมูลกลุ่ม Hunt",
      get_number_fail: "ไม่พบข้อมูลหมายเลข",
      get_pilot_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
      update_number_fail: "แก้ไขข้อมูลหมายเลขผิดพลาด",
      delete_number_fail: "การลบข้อมูลหมายเลขผิดพลาด",
      redeem_dummy_pilot_failed: "ไม่สามารถคืนหมายเลขนำหมู่",
      number_duplicate: "มีหมายเลขนี้แล้วในกลุ่ม Hunt",
      number_not_in_corp: "ไม่มีหมายเลขนี้ในองค์กร",
      invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
      invalid_realnumber: "รูปแบบหมายเลข Real ไม่ถูกต้อง",
      access_denie: "ผู้ใช้งานไม่มีสิทธิ์ในการเข้าถึงข้อมูลนี้"
    },
    auth: {
      login_fail: "เข้าสู่ระบบผิดพลาด",
      block: "ผู้ใช้งานถูกระงับ",
      login_success: "เข้าสู่ระบบสำเร็จ",
      logout_success: "ออกจากระบบสำเร็จ",
      unauthoriezed: "เข้าสู่ระบบผิดพลาด",
      reset_invalid_token: "token ไม่ถูกต้อง",
      reset_token_expired: "token หมดอายุ",
      forgot_pass_fail: "ลืมรหัสผ่านไม่สำเร็จ",
      reset_pass_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
      pass_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
      token: "Token ไม่ถูกต้อง",
      pass: "รหัสผ่านไม่ถูกต้อง",
      pass_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      request_twofa_fail: "การขอรหัส OTP ผิดพลาด",
      verify_twofa_fail: "การยืนยัน OTP ผิดพลาด",
      maintenance_active: "ระบบอยู่ระหว่างปรับปรุง กรุณาลองอีกครั้งภายหลัง"
    },
    otp: {
      request_otp_fail: "การขอรหัส OTP ผิดพลาด",
      verify_otp_fail: "การยืนยัน OTP ผิดพลาด"
    },
    package: {
      duplicate_code: "รหัสแพ็คเกจซ้ำ",
      duplicate_name: "ชื่อแพ็คเกจซ้ำ",
      not_exist: "ไม่พบข้อมูลแพ็คเกจ",
      delete_lock: "ไม่สามารถลบข้อมูลแพ็คเกจได้ เนื่องจากมีการใช้งาน",
      get_profile_failed: "ไม่พบข้อมูลของแพ็กเกจ VPBX ในระบบ"
    },
    subs: {
      invalid_number: "รูปแบบหมายเลขไม่ถูกต้อง",
      invalid_pilot_number: "รูปแบบหมายเลขนำหมู่ไม่ถูกต้อง",
      invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
      invalid_mapping_number: "รูปแบบหมายเลข Mapping ไม่ถูกต้อง",
      invalid_agent_number: "รูปแบบหมายเลขผู้ใช้งานไม่ถูกต้อง",
      invalid_main_number: "รูปแบบหมายเลของค์กรไม่ถูกต้อง",
      invalid_charge_number: "รูปแบบหมายเลขที่คิดค่าใช้จ่ายไม่ถูกต้อง",
      invalid_alt_number: "รูปแบบหมายเลข Alternative ไม่ถูกต้อง",
      invalid_real_number: "รูปแบบหมายเลข Real ไม่ถูกต้อง",
      invalid_additional_number: "รูปแบบหมายเลข Additional ไม่ถูกต้อง",
      invalid_email: "รูปแบบอีเมล์ไม่ถูกต้อง",
      not_exist: "ไม่พบหมายเลขนี้",
      corp_not_match: "ข้อมูลองค์กรไม่ถูกต้อง",
      get_crop_id_failed: "ไม่พบข้อมูลองค์กรหรือหมายเลของค์กร",
      duplicate: "หมายเลขซ้ำ",
      get_charge_number_failed: "ไม่พบข้อมูลหมายเลขโทรศัพท์ภายใต้บริษัทนี้",
      set_charge_number_failed: "ไม่สามารถเปลี่ยนข้อมูลหมายเลขนี้",
      get_brn_failed: "ไม่พบข้อมูลหมายเลข BRN",
      is_mlhg_member: "หมายเลขนี้เป็นสมาชิกของกลุ่ม Hunt",
      number_range_delete_fail: "ไม่สามารถลบข้อมูลช่วงหมายเลข",
      comp_login_failed: "เข้าสู่ระบบ ComPortal ผิดพลาด",
      idcard_validate_fail: "ข้อมูลหมายเลขไม่ถูกต้อง",
      subs_status_failed: "หมายเลขนี้ไม่มีสิทธิ์สมัครบริการนี้",
      import_number: "อัพโหลดหมายเลขผู้ใช้งานผิดพลาด",
      reset_pass_fail: "รีเซ็ตรหัสผ่านผิดพลาด",
      delete_failed: "ลบหมายเลขผิดพลาด",
      delete_pilot_number_failed: "ลบหมายเลขนำหมู่ผิดพลาด",
      delete_number_block_failed: "ลบ Number Block ผิดพลาด",
      number_in_mlhg: "หมายเลขนี้ถูกใช้งานในกลุ่ม Hunt",
      sync_package_fail: "ซิงค์ข้อมูลแพ็คเกจผิดพลาด",
      sync_package_partial: "ซิงค์ข้อมูลแพ็คเกจสำเร็จบางส่วน"
    },
    profile: {
      get_profile_failed: "เรียกข้อมูลผู้ใช้งานผิดพลาด",
      change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
      change_pass_failed: "แก้ไขรหัสผ่านผิดพลาด",
      pass_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      pass_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ถูกต้อง",
      pass_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
    },
    report: {
      date_over_60: "ช่วงเวลาที่เลือกเกิน 60 วัน",
      date_over_90: "ช่วงเวลาที่เลือกเกิน 90 วัน",
      date_over_30:
        "ไม่สามารถค้นหาข้อมูลได้เกิน 60 วัน และถ้าค้นหาข้อมูลมากกว่า 30 วันการค้นหาอาจจะเกิดความล่าช้า"
    }
  },

  bc_portal: "Web Portal",
  bc_package: "แพ็คเกจ",
  bc_voicemail: "ข้อความเสียง",
  bc_report: "รายงานการโทร",
  bc_record: "ข้อมูลการโทร",
  bc_user: "ผู้ใช้งาน",
  bc_corporate: "องค์กร",
  bc_mlhg: "กลุ่ม Hunt",
  bc_pilot_number: "หมายเลของค์กร",
  bc_agent_number: "หมายเลขผู้ใช้งาน",
  bc_mapping_number: "หมายเลข mapping",
  bc_import_number: "นำเข้าหมายเลขผู้ใช้งาน",
  bc_capacity: "ความจุ EAS",
  bc_change_profile: "ข้อมูลส่วนตัว",
  bc_change_pass: "เปลี่ยนรหัสผ่าน",

  profile: {
    profile: "ข้อมูลส่วนตัว",
    name: "ชื่อ",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล์",
    change_pass: "เปลี่ยนรหัสผ่าน",
    pass_old: "รหัสผ่านเดิม",
    pass_new: "รหัสผ่านใหม่",
    pass_confirm: "ยืนยันรหัสผ่าน",
    change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
    change_pass_success: "เปลี่ยนรหัสผ่านสำเร็จ",
    forgot_pass_success: "ส่งคำขอลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
    reset_pass_success: "เปลี่ยนรหัสผ่านสำเร็จ"
  },
  menu: {
    corporate: "องค์กร",
    mlhg: "กลุ่ม Hunt",
    package: "แพ็คเกจ",
    pilot_number: "หมายเลของค์กร",
    agent_number: "หมายเลขผู้ใช้งาน",
    import_agent_number: "นำเข้าหมายเลขผู้ใช้งาน",
    number: "หมายเลข",
    user: "ผู้ใช้งาน",
    voicemail: "ข้อความเสียง",
    cdr: "ข้อมูลการโทร",
    report: "รายงานการโทร",
    nseries: "การประชุมผ่านโทรศัพท์",
    capacity: "ความจุ EAS",
    easmigration: "ย้าย EAS Server",
    voicemaillog: "ประวัติข้อความเสียง",
    corporate_v4: "องค์กร (v4)",
    pilot_number_v4: "หมายเลของค์กร (v4)",
    agent_number_v4: "หมายเลขผู้ใช้งาน (v4)"
  },
  eas_server: "EAS Server",
  capacity: {
    title: "ความจุ EAS",
    server: "EAS Server",
    capacity: "ความจุสูงสุด",
    used: "ใช้งานแล้ว",
    available: "คงเหลือ",
    corporates: "องค์กร",
    pilot_numbers: "หมายเลของค์กร",
    agent_numbers: "หมายเลขผู้ใช้งาน",
    system_total: "ความจุรวมของระบบ",
    detail: "รายละเอียดตาม EAS Server"
  },
  easmigration: {
    success: "ตรวจสอบก่อนย้ายเรียบร้อย",
    started: "เพิ่มรายการย้ายเข้าคิวแล้ว",
    // #41: การอ่านข้อมูลเป็นคนละคำสั่งกับการย้าย และไม่ลบข้อมูลใด ๆ
    read_started: "เพิ่มรายการอ่านข้อมูลเข้าคิวแล้ว",
    // แสดงแทนตัวเลขเมื่อ EAS Server ปลายทางไม่จำกัดความจุ
    // หรือไม่ทราบความจุ (ไม่พบเครื่องในไฟล์ตั้งค่า)
    capacity_unlimited: "ไม่จำกัด",
    capacity_unknown: "ไม่ทราบ",

    // ---- issue #35: หน้าจอย้าย EAS Server ----
    title: "ย้าย EAS Server",
    help:
      "ย้ายทั้งองค์กร (รวมสาขาย่อย) ไปยัง EAS Server เครื่องใหม่ ทำได้ 3 ขั้นตอน: ตรวจสอบ → อ่านข้อมูล → ยืนยันเริ่มย้าย ขั้นตอนที่ 3 จะลบข้อมูลออกจากเครื่องต้นทางให้ครบก่อนแล้วจึงสร้างบนเครื่องปลายทาง องค์กรจะใช้งานไม่ได้ตลอดช่วงนั้น",
    tab_migration: "การย้าย",
    tab_logs: "บันทึกการทำงาน",
    corporate: "องค์กร",
    corporate_placeholder: "เลือกองค์กรหลัก",
    target_eas: "EAS Server ปลายทาง",
    target_eas_placeholder: "เลือก EAS Server ปลายทาง",
    current_eas: "EAS Server ปัจจุบัน",
    no_eas: "ยังไม่ได้ผูก EAS Server",
    none: "ไม่มี",
    refresh: "โหลดสถานะใหม่",

    check_button: "ตรวจสอบก่อนย้าย",
    preflight_title: "ผลการตรวจสอบ",
    blocking_title: "ปัญหาที่ต้องแก้ก่อน",
    warnings_title: "คำเตือน",
    no_warnings: "ไม่มีคำเตือน",
    preflight_passed: "ตรวจสอบผ่าน สามารถอ่านข้อมูลได้",
    counts_title: "จำนวนรายการที่จะย้าย",
    count_bg: "Business Group",
    count_numbers: "หมายเลข",
    count_mlhg: "Pilot Line ของ Hunt Group",
    count_skipped_alt: "หมายเลขสำรอง (ไม่ต้องย้าย)",
    count_total: "รวมรายการที่ต้องทำ",
    capacity_title: "ความจุ EAS Server ปลายทาง",
    capacity_capacity: "ความจุสูงสุด",
    capacity_used: "ใช้งานแล้ว",
    capacity_available: "คงเหลือ",
    capacity_required: "ต้องใช้เพิ่ม",
    sub_branches: "สาขาย่อยที่จะถูกย้ายไปด้วย",

    read_button: "อ่านข้อมูล",
    read_help:
      "การอ่านข้อมูลจะดึงข้อมูลทั้งหมดจาก MetaSwitch มาเก็บไว้ ไม่มีการลบหรือแก้ไขสิ่งใดทั้งสิ้น",
    authorise_title: "ยืนยันเริ่มการย้าย",
    authorise_help:
      "อ่านข้อมูลเรียบร้อยแล้ว ขั้นตอนต่อไปจะลบและสร้างข้อมูลจริงบน MetaSwitch และเป็นขั้นตอนที่ทำให้องค์กรใช้งานไม่ได้",
    read_completed_at: "อ่านข้อมูลเสร็จเมื่อ",
    read_age: "อ่านมาแล้ว",
    voicemail_confirm:
      "ข้าพเจ้ารับทราบว่าข้อความ Voicemail ที่เก็บอยู่บน EAS Server ต้นทางจะถูกลบอย่างถาวร",
    start_button: "เริ่มการย้าย",

    progress_read_title: "กำลังอ่านข้อมูล",
    progress_title: "กำลังย้าย EAS Server",
    phase_label: "ขั้นตอน",
    current_object: "รายการล่าสุด",
    elapsed: "เวลาที่ใช้",
    done_label: "สำเร็จ",
    error_label: "ผิดพลาด",
    total_label: "ทั้งหมด",

    // ---- ช่วงที่องค์กรใช้งานไม่ได้ (outage) ----
    //
    // ลำดับใหม่คือ "ลบให้ครบก่อน แล้วจึงสร้าง" ไม่ใช่ลบ-สร้างทีละหมายเลข
    // อย่างเดิม ระหว่างสองช่วงนี้หมายเลขทั้งองค์กรจะไม่อยู่บน EAS Server
    // เครื่องใดเลย ข้อความชุดนี้มีไว้เพื่อไม่ให้ผู้ปฏิบัติงานเข้าใจผิดว่า
    // เป็นการกระพริบสั้น ๆ ทีละหมายเลข เพราะถ้าเข้าใจผิดจะไม่จองช่วงเวลาปิดบริการ
    pass_label: "ช่วงการทำงาน",
    pass_read: "อ่านข้อมูล",
    pass_delete: "ลบออกจากต้นทาง",
    pass_create: "สร้างบนปลายทาง",
    pass_settle: "บันทึกและตรวจสอบ",
    pass_read_hint: "ไม่ลบและไม่แก้ไขสิ่งใด",
    // ข้อความสองบรรทัดนี้คือลำดับขั้นตอนของแต่ละช่วง โดย extension อยู่ริมสุด
    // ทั้งสองด้าน คือถูกลบออกจากต้นทางเป็นอันดับแรก และถูกเขียนกลับบนปลายทาง
    // เป็นลำดับสุดท้าย การระบุไว้ตรงนี้คือสิ่งที่บอกผู้ปฏิบัติงานว่างานนี้
    // รวมถึงรายการหมายเลขภายในด้วย
    pass_delete_hint: "extension → agent → mlhg → bg",
    pass_create_hint: "bg → mlhg → subscriber → extension",
    pass_settle_hint: "องค์กรใช้งานได้แล้ว",

    outage_title: "องค์กรใช้งานไม่ได้ตลอดช่วงนี้",
    outage_bracket: "ใช้งานไม่ได้ทั้งสองช่วง",
    // กฎข้อเดียวที่ต้องอ่านให้เข้าใจ ระบุไว้ทั้งก่อนกดยืนยันและระหว่างทำงาน
    outage_rule:
      "ระบบจะลบข้อมูลออกจาก EAS Server ต้นทางให้ครบทุกรายการก่อน แล้วจึงเริ่มสร้างบนเครื่องปลายทาง",
    outage_window_hint:
      "ระยะเวลาที่ใช้งานไม่ได้คือเวลาของทั้งงานนี้ ไม่ใช่เวลาต่อหนึ่งหมายเลข กรุณาจองช่วงเวลาปิดบริการให้ครอบคลุมทั้งงาน",
    outage_pending:
      "ยังไม่ได้ลบสิ่งใด องค์กรยังใช้งานได้ตามปกติ ช่วงที่ใช้งานไม่ได้จะเริ่มเมื่อการลบรายการแรกถูกส่งออกไป",
    outage_open_delete:
      "องค์กรใช้งานไม่ได้แล้ว ขณะนี้อยู่ในช่วงลบข้อมูลออกจาก EAS Server ต้นทาง ยังไม่มีการสร้างสิ่งใดบนเครื่องปลายทาง และจะไม่กลับมาใช้งานได้จนกว่าช่วงสร้างจะเสร็จ",
    outage_open_create:
      "องค์กรยังใช้งานไม่ได้ ลบออกจากต้นทางครบแล้วและกำลังสร้างบนเครื่องปลายทาง หมายเลขจะทยอยกลับมาใช้งานได้ตามที่สร้างสำเร็จ และจะครบทั้งองค์กรเมื่อรายการสุดท้ายเสร็จ",
    outage_open_failed:
      "งานหยุดกลางช่วงที่ใช้งานไม่ได้ องค์กรยังใช้งานไม่ได้อยู่ในขณะนี้ และจะไม่กลับมาเอง กรุณากด “ทำต่อจากที่ค้างไว้” จนสำเร็จ",
    outage_closed: "สร้างครบทุกรายการแล้ว องค์กรกลับมาใช้งานได้",

    // ชื่อขั้นตอน ต้องตรงกับค่าคงที่ EasMigrationPhase*V4 ใน
    // controllers/WPEasMigrationStoreV4.go ทุกตัว
    phase_preflight: "ตรวจสอบก่อนย้าย",
    phase_snapshot: "อ่านและบันทึกข้อมูลเดิม",
    phase_plan: "ตรวจความพร้อมครั้งสุดท้าย (ยังไม่ลบสิ่งใด)",
    // รายการหมายเลขภายในเป็นข้อมูลระดับ Business Group (Intercom Code Range)
    // จึงหายไปพร้อมกับ Business Group ระบบจะลบรายการนี้ก่อนลบสิ่งอื่นทั้งหมด
    // และเขียนกลับหลังสร้างสิ่งอื่นครบแล้ว คือเป็นรายการนอกสุดของงานทั้งสองทิศทาง
    phase_delete_extension:
      "ลบรายการหมายเลขภายใน (Intercom Code) บนต้นทาง",
    phase_delete_subs: "ลบหมายเลขออกจากต้นทาง",
    phase_delete_mlhg: "ลบ Pilot Line ของ Hunt Group ออกจากต้นทาง",
    phase_delete_bg: "ลบ Business Group ต้นทาง",
    phase_create_bg: "สร้าง Business Group ปลายทาง",
    phase_create_mlhg: "สร้าง Pilot Line ของ Hunt Group บนปลายทาง",
    phase_create_subs: "สร้างหมายเลขบนปลายทางและอัปเดต Termination",
    phase_create_extension:
      "เขียนรายการหมายเลขภายใน (Intercom Code) กลับคืนบนปลายทาง",
    phase_commit: "บันทึกลงฐานข้อมูล",
    phase_verify: "ตรวจสอบผลลัพธ์",
    // ขั้นตอนเดิมที่เลิกใช้แล้ว (ลบและสร้างทีละหมายเลขสลับกันไป) ไม่มีการเขียนค่านี้
    // อีกแล้ว แต่แถวเก่าในฐานข้อมูลยังมีอยู่ จึงต้องยังแปลได้
    phase_numbers: "ย้ายหมายเลขทีละเบอร์ (ลำดับเดิม — เลิกใช้แล้ว)",
    // ขั้นตอน extension แบบเดิมที่ "ตรวจแล้วค่อยกู้คืน" ซึ่งทำงานครั้งเดียวตอนท้าย
    // และเขียนข้อมูลก็ต่อเมื่อพบว่ามีรายการหายไปแล้วเท่านั้น ไม่ใช่ขั้นตอนใดใน
    // สองขั้นตอนข้างต้น จึงใช้ชื่อที่ไม่กล่าวอ้างว่างานเก่าทำอะไรไปบ้าง
    phase_retired: "ขั้นตอนที่เลิกใช้แล้ว",
    phase_unknown: "ไม่ทราบขั้นตอน",

    status_queued: "รอในคิว",
    status_running: "กำลังทำงาน",
    status_success: "สำเร็จ",
    status_failed: "ล้มเหลว",
    status_read_ok: "อ่านข้อมูลแล้ว",
    status_unknown: "ไม่ทราบสถานะ",

    item_pending: "รอดำเนินการ",
    item_done: "สำเร็จ",
    item_not_attempted: "ยังไม่ได้ทำ",
    item_failed: "ล้มเหลว",
    item_skipped: "ข้าม",
    item_unknown: "ไม่ทราบ",

    job_title: "รายการย้ายล่าสุด",
    job_id: "เลขที่รายการ",
    source: "ต้นทาง",
    target: "ปลายทาง",
    job_status: "สถานะ",
    attempt: "ครั้งที่",
    result_title: "ผลรายการย่อย",
    col_seq: "ลำดับ",
    col_kind: "ประเภท",
    col_object: "ชื่อบน MetaSwitch",
    col_delete: "ลบต้นทาง",
    col_create: "สร้างปลายทาง",
    col_repoint: "Termination",
    col_verify: "ตรวจสอบ",
    col_result_code: "รหัสผล",
    col_error: "ข้อผิดพลาด",
    col_updated: "อัปเดตเมื่อ",
    no_items: "ยังไม่มีรายการย่อย",

    // ข้อมูลที่ขั้นตอนอ่านข้อมูลเก็บไว้ของรายการย่อยนั้น ๆ
    // ดึงมาเฉพาะตอนกดเปิดดูเท่านั้น
    col_snapshot: "ข้อมูลที่อ่านมา",
    view_snapshot: "ดูข้อมูลที่อ่านมา",
    snapshot_title: "ข้อมูลที่อ่านมาได้",
    snapshot_empty: "ขั้นตอนอ่านข้อมูลไม่ได้เก็บข้อมูลของรายการย่อยนี้ไว้",
    snapshot_masked:
      "ค่า PIN และรหัสผ่านถูกปิดบังไว้ ค่าจริงเก็บอยู่ในฐานข้อมูลเท่านั้น เพื่อให้ขั้นตอนสร้างใหม่นำไปใช้ได้",
    snapshot_truncated: "แสดง {shown} จากทั้งหมด {total} รายการที่เก็บไว้ของรายการย่อยนี้",
    snapshot_seq: "ลำดับที่",
    snapshot_half_cfs: "CFS",
    snapshot_half_eas: "EAS",
    snapshot_half_unknown: "ไม่ทราบเซิร์ฟเวอร์",

    retry_button: "ทำต่อจากที่ค้างไว้",
    retry_title: "ทำรายการที่ค้างไว้ต่อ?",
    // ต้องสื่อให้ชัดว่าไม่ได้เริ่มใหม่ทั้งหมด ระบบจะตรวจสอบสถานะจริงบน MetaSwitch
    // ของแต่ละรายการก่อน แล้วทำเฉพาะส่วนที่ยังไม่เสร็จ
    retry_text:
      "ระบบจะตรวจสอบสถานะจริงบน MetaSwitch ของแต่ละรายการอีกครั้ง แล้วทำต่อเฉพาะรายการที่ยังไม่เสร็จ ไม่ได้เริ่มใหม่ทั้งหมด ขณะนี้เหลืออีก {count} รายการ",
    // ใช้เมื่อหน้าจอยังไม่ได้รับรายการย่อยครบทุกรายการ จึงยังนับจำนวนที่เหลือ
    // ไม่ได้ แจ้งจำนวนที่ต่ำกว่าความจริงอันตรายกว่าการไม่แจ้งจำนวนเลย
    retry_text_unknown:
      "ระบบจะตรวจสอบสถานะจริงบน MetaSwitch ของแต่ละรายการอีกครั้ง แล้วทำต่อเฉพาะรายการที่ยังไม่เสร็จ ไม่ได้เริ่มใหม่ทั้งหมด (รายการย่อยมีจำนวนมากเกินกว่าที่หน้านี้จะแสดงได้ทั้งหมด จึงยังระบุจำนวนที่เหลือไม่ได้)",
    retry_yes: "ใช่, ทำต่อ",
    // รายการที่ล้มเหลวตั้งแต่ขั้นอ่านข้อมูล ยังไม่เคยถูกอนุมัติให้ย้าย
    // จึงกด "ทำต่อจากที่ค้างไว้" ไม่ได้ ทางแก้คือกดอ่านข้อมูลใหม่อีกครั้ง
    reread_required:
      "รายการนี้ล้มเหลวตั้งแต่ขั้นอ่านข้อมูล ยังไม่ได้เริ่มย้ายอะไรทั้งสิ้น จึงไม่มีงานให้ทำต่อ กรุณากด “อ่านข้อมูล” ใหม่อีกครั้งเพื่อเริ่มต้นใหม่",

    logs_title: "บันทึกการทำงาน",
    log_help: "แสดงบันทึกของรายการย้ายที่เลือกอยู่ รวมถึง SOAP ที่ส่งและได้รับ",
    log_level: "ระดับ",
    log_level_all: "ทุกระดับ",
    log_attempt: "ครั้งที่",
    log_attempt_all: "ทุกครั้ง",
    // รายการตัวเลือกสร้างจากขั้นตอนและฟังก์ชันที่งานนี้ทำไว้จริง
    // งานที่หยุดกลางทางจึงมีตัวเลือกไม่เท่ากับงานที่ทำจนจบ
    log_phase: "ขั้นตอน",
    log_phase_all: "ทุกขั้นตอน",
    log_func: "ฟังก์ชัน",
    log_func_all: "ทุกฟังก์ชัน",
    search: "ค้นหา",
    col_time: "เวลา",
    col_phase: "ขั้นตอน",
    col_level: "ระดับ",
    col_func: "ฟังก์ชัน",
    col_message: "ข้อความ",
    col_soap: "SOAP",
    view_soap: "ดู SOAP",
    soap_title: "SOAP Envelope",
    copy_soap: "คัดลอก SOAP",
    no_logs: "ไม่มีบันทึกการทำงาน",
    select_job_first: "กรุณาเลือกหรือเริ่มรายการย้ายก่อน",

    // ---- สำรอง Voicemail ก่อนย้าย EAS Server ----
    //
    // การย้าย EAS Server จะลบข้อความเสียงทั้งหมดบนเครื่องต้นทางอย่างถาวร
    // ปุ่มนี้จึงต้องอยู่ก่อนขั้นตอนย้ายเสมอ เมื่อเริ่มลบข้อมูลไปแล้วจะไม่มีอะไรให้สำรองอีก
    vm_button: "สำรองข้อความเสียง",
    vm_help:
      "สำรองข้อความเสียงของทุกหมายเลขในองค์กรที่เลือก เก็บเป็นไฟล์ ZIP ไว้บนเซิร์ฟเวอร์ก่อนเริ่มการย้าย EAS Server เพราะข้อความเสียงบนเครื่องต้นทางจะถูกลบอย่างถาวร ไฟล์ที่สำรองไว้จะถูกเก็บไว้ ดาวน์โหลดหรือกู้คืนภายหลังได้จากหน้าประวัติสำรอง/กู้คืนข้อความเสียง",
    vm_title: "สำรองข้อความเสียง (Voicemail)",
    // ชื่อสามขั้นตอนในแถบความคืบหน้า ทั้งสามขั้นเป็น Phase ของระบบเบื้องหลังทั้งหมด
    // เพราะหน้าจอนี้ไม่มีขั้นตอนของตัวเองต่อจากไฟล์ ZIP สร้างเสร็จอีกต่อไป
    vm_step_read: "อ่านข้อความ",
    vm_step_read_hint: "อ่านทีละหมายเลข",
    vm_step_compress: "บีบอัด",
    vm_step_compress_hint: "รวมเป็นไฟล์ ZIP",
    vm_step_ready: "พร้อมใช้งาน",
    vm_step_ready_hint: "ไฟล์ ZIP อยู่บนเซิร์ฟเวอร์",
    vm_progress_label: "ความคืบหน้า",
    vm_current_number: "กำลังอ่านหมายเลข",
    // ระบบเบื้องหลังยังไม่ได้รายงานหมายเลข ไม่ใช่ว่าค้าง
    vm_current_none: "กำลังเตรียมข้อมูล...",
    vm_messages: "ข้อความ",
    vm_errors: "ผิดพลาด",
    vm_elapsed: "เวลาที่ใช้",
    vm_size: "ขนาดไฟล์",
    vm_ready_text:
      "สำรองข้อความเสียงเรียบร้อยแล้วครบทุกหมายเลข ไฟล์ ZIP ถูกเก็บไว้บนเซิร์ฟเวอร์แล้ว",
    // สำรองเสร็จแต่มีบางหมายเลขอ่านไม่ได้ ต้องบอกให้ชัดก่อนที่ผู้ปฏิบัติงาน
    // จะเข้าใจว่า "สำรองครบแล้ว" แล้วสั่งย้าย ซึ่งจะทำให้ข้อความที่อ่านไม่ได้หายถาวร
    vm_partial:
      "สำรองข้อมูลเสร็จแล้ว แต่มีบางหมายเลขที่ไม่ได้ถูกเก็บลงไฟล์สำรอง อาจเพราะอ่านจากเครื่องไม่สำเร็จ หรือเครื่องตอบว่าสำเร็จแต่ไม่ได้ส่งข้อมูลข้อความเสียงกลับมา ไฟล์ ZIP จึงไม่ครบทุกหมายเลข กรุณาเปิดหน้าประวัติสำรอง/กู้คืนข้อความเสียงแล้วกดดูผลรายหมายเลข เพื่อตรวจสอบว่าหมายเลขใดไม่สมบูรณ์ ก่อนเริ่มการย้าย EAS Server",
    vm_error_title: "สำรองข้อความเสียงไม่สำเร็จ",
    vm_error_log_title: "รายละเอียดจากระบบเบื้องหลัง",
    vm_failed: "สำรองข้อความเสียงไม่สำเร็จ",
    vm_download_failed: "ดาวน์โหลดไฟล์สำรองไม่สำเร็จ",
    // ปุ่มดาวน์โหลดจะแสดงก็ต่อเมื่อ Downloadable เป็น true เท่านั้น
    // ไม่ได้ดูจาก Phase เพราะงานที่ ready แล้วอาจถูกรอบเก็บรักษาข้อมูลลบไฟล์ไปแล้ว
    vm_download_button: "ดาวน์โหลดไฟล์ ZIP",
    // Phase เป็น "ready" แต่ Downloadable เป็น false
    // คือสถานะยังบอกว่าเสร็จแล้ว แต่ไฟล์ไม่ได้อยู่บนดิสก์แล้ว
    vm_file_missing:
      "สำรองข้อมูลเสร็จแล้ว แต่ไม่มีไฟล์อยู่บนเซิร์ฟเวอร์แล้ว ไฟล์อาจถูกล้างตามรอบเก็บรักษาข้อมูลหรือหายไปพร้อมกับโปรเซสที่สร้างไฟล์ กรุณาสำรองข้อมูลใหม่ก่อนเริ่มการย้าย EAS Server",
    // StatusName เป็น failed ทั้งที่ Phase ยังไม่ได้บอกว่าผิดพลาด
    // เกิดเมื่อโปรเซสเบื้องหลังถูกหยุดกลางคัน
    vm_worker_stopped:
      "ระบบเบื้องหลังที่ทำงานสำรองข้อมูลนี้หยุดทำงานก่อนเสร็จ ไฟล์สำรองจึงไม่ครบทุกหมายเลข กรุณาสำรองข้อมูลใหม่ก่อนเริ่มการย้าย EAS Server",
    // ระบบตอบว่าสำเร็จแต่ไม่ได้ส่งรหัสงานกลับมา จึงไม่มีอะไรให้ติดตามต่อ
    vm_no_job_id:
      "ระบบไม่ได้ส่งรหัสงานสำรองข้อมูลกลับมา จึงไม่สามารถติดตามสถานะหรือดาวน์โหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง",
    failed: "ทำรายการไม่สำเร็จ"
  },

  // ค่า Msg ฝั่งสำเร็จที่ endpoint สำรอง/กู้คืนข้อความเสียงส่งกลับมา
  // ปัจจุบันหน้าจอยังไม่ได้แสดงค่าเหล่านี้ เพราะขับเคลื่อนขั้นตอนจาก Phase
  // และใช้ข้อความของตัวเอง แต่ค่าเหล่านี้จะถูกส่งเข้า getErrorText() ทันที
  // ที่มีใครนำ Msg ฝั่งสำเร็จมาแสดง และคีย์ที่แปลไม่ได้จะโชว์เป็น path ดิบ
  // ตรวจความครบถ้วนคู่กับ en.js ด้วย scripts/check-i18n-keys.js
  // ---- หน้าประวัติสำรอง/กู้คืนข้อความเสียง (VoicemailBackupLog.vue) ----
  //
  // namespace แยกจาก voicemailbackup ด้านล่างโดยตั้งใจ: ด้านล่างคือคีย์ที่
  // backend เป็นผู้สะกดและส่งกลับมาเป็น Msg ส่วนบล็อกนี้เป็นข้อความของหน้าจอเอง
  // ถ้าปนกันไว้ที่เดียว การตั้งชื่อคีย์ใหม่ของหน้าจอจะไปชนกับคีย์ที่ Go ส่งมาได้
  voicemaillog: {
    title: "สำรอง/กู้คืนข้อความเสียง",
    list_title: "รายการงานสำรองและกู้คืน",
    help:
      "รายการงานสำรอง (backup) และกู้คืน (restore) ข้อความเสียงทั้งหมดในระบบ ใช้ดาวน์โหลดไฟล์ ZIP ที่สำรองไว้ ดูผลรายหมายเลข และกู้คืนข้อความเสียงกลับเข้าเครื่องหลังย้าย EAS Server",
    search: "ค้นหา",
    filter_kind: "ประเภทงาน",
    kind_all: "ทั้งหมด",
    kind_backup: "สำรองข้อมูล",
    kind_restore: "กู้คืนข้อมูล",
    filter_corporate: "องค์กร",
    corporate_all: "ทุกองค์กร",

    col_kind: "ประเภท",
    col_corporate: "องค์กร",
    col_created: "เริ่มเมื่อ",
    col_by: "ผู้ทำรายการ",
    col_numbers: "หมายเลข",
    col_counts: "ข้อความ / ข้อผิดพลาด",
    col_status: "สถานะ",
    col_size: "ขนาดไฟล์",
    col_actions: "การจัดการ",
    messages_label: "ข้อความ",
    errors_label: "ผิดพลาด",
    no_file: "ไม่มีไฟล์",
    no_rows: "ไม่พบรายการ",

    btn_download: "ดาวน์โหลด",
    btn_log: "ดูผลรายหมายเลข",
    btn_restore: "กู้คืน",

    // ---- อัปโหลดไฟล์สำรองเพื่อกู้คืน ----
    //
    // ปุ่มนี้เป็นการกู้คืนแบบเดียวที่ไม่ผูกกับแถวในตาราง
    // API ทำงานอยู่สองเครื่องหลัง nginx โดยไม่มีดิสก์ร่วมกัน
    // ไฟล์สำรองบนเซิร์ฟเวอร์จึงเป็นแค่ไฟล์ชั่วคราว อยู่บนเครื่องที่สร้างมันเท่านั้น
    // และถูกล้างตามรอบเก็บรักษาข้อมูล
    // ไฟล์ที่ผู้ปฏิบัติงานกดดาวน์โหลดเก็บไว้เองคือต้นฉบับที่ใช้กู้คืนได้จริงในภายหลัง
    upload_button: "อัปโหลดไฟล์สำรองเพื่อกู้คืน",
    upload_hint:
      "เซิร์ฟเวอร์เก็บไฟล์สำรองไว้ชั่วคราวเท่านั้น ไฟล์ ZIP ที่ดาวน์โหลดเก็บไว้เองจึงกู้คืนได้ด้วยการอัปโหลดกลับเข้ามาที่นี่",
    upload_title: "อัปโหลดไฟล์สำรองเพื่อกู้คืนข้อความเสียง",
    upload_corporate: "องค์กรที่เป็นเจ้าของไฟล์สำรองนี้",
    upload_corporate_placeholder: "-- เลือกองค์กร --",
    upload_file: "ไฟล์สำรอง (.zip)",
    upload_file_placeholder: "เลือกไฟล์ ZIP ที่ดาวน์โหลดเก็บไว้",
    // อธิบายซ้ำตรงนี้ เพราะทางเข้านี้ไม่มีหน้าต่างยืนยันแบบกดจากแถวในตาราง
    // ผู้ปฏิบัติงานเลือกไฟล์มาจากโฟลเดอร์ดาวน์โหลด จึงไม่มีชื่อองค์กรและวันที่ให้ตรวจ
    upload_explain:
      "ระบบจะนำข้อความเสียงในไฟล์สำรองนี้ รวมกลับเข้ากล่องข้อความของหมายเลขที่ระบุอยู่ภายในไฟล์ ไม่ใช่การเขียนทับ ข้อความที่เข้ามาใหม่หลังวันที่สำรองจะยังอยู่ครบ และข้อความที่มีอยู่แล้วจะไม่ถูกเพิ่มซ้ำ องค์กรที่เลือกตรงนี้ต้องเป็นองค์กรเดียวกับที่ไฟล์นี้ถูกสำรองมา ระบบจะตรวจสอบให้อีกครั้งและจะปฏิเสธถ้าไม่ตรงกัน",
    upload_confirm: "อัปโหลดและกู้คืน",
    upload_uploading:
      "กำลังอัปโหลด {percent}% กรุณาอย่าปิดหน้าต่างนี้จนกว่าจะอัปโหลดเสร็จ",
    upload_failed: "อัปโหลดไฟล์สำรองเพื่อกู้คืนไม่สำเร็จ",

    // Phase ทั้งเจ็ดค่า สามค่าแรกเป็นของงานสำรอง สามค่าถัดมาเป็นของงานกู้คืน
    phase_read: "กำลังอ่านข้อความ",
    phase_compress: "กำลังบีบอัดไฟล์",
    phase_ready: "พร้อมดาวน์โหลด",
    phase_extract: "กำลังแตกไฟล์",
    phase_restore: "กำลังรวมข้อความ",
    phase_done: "เสร็จสมบูรณ์",
    phase_error: "ผิดพลาด",

    status_queued: "รอคิว",
    status_running: "กำลังทำงาน",
    status_ready: "พร้อมใช้งาน",
    status_failed: "ล้มเหลว",

    action_read: "อ่าน",
    action_restore: "รวมข้อความ",
    // ผลรายหมายเลขมีสามค่า ไม่ใช่สองค่า
    // no_data คือ "เครื่องตอบกลับมาแล้ว แต่ไม่มีอะไรถูกเก็บลงไฟล์สำรอง"
    // ต้องไม่อ่านว่าสำเร็จ และต้องไม่อ่านว่าติดต่อเครื่องไม่ได้
    result_ok: "อ่านสำเร็จ",
    result_error: "ผิดพลาด",
    result_no_data: "ไม่มีข้อมูล",

    log_title: "ผลรายหมายเลข",
    log_col_seq: "ลำดับ",
    log_col_number: "หมายเลข",
    log_col_action: "การทำงาน",
    log_col_result: "ผล",
    log_col_messages: "จำนวนข้อความ",
    log_col_detail: "รายละเอียด",
    log_col_time: "เวลา",
    log_none: "ยังไม่มีผลรายหมายเลขสำหรับงานนี้",
    // ผู้ปฏิบัติงานเข้ามาหน้านี้จากคำเตือนสีเหลืองว่า "ไฟล์สำรองไม่ครบ"
    // จึงต้องอธิบายให้ชัดว่าสามสถานะต่างกันอย่างไร
    log_legend:
      "อ่านสำเร็จ = อ่านข้อความจากเครื่องได้ครบ (รวมถึงกล่องข้อความที่ว่างจริง ๆ) · ไม่มีข้อมูล = เครื่องตอบกลับมาว่าสำเร็จ แต่ไม่ได้ส่งข้อมูลข้อความเสียงของหมายเลขนี้มาเลย จึงไม่มีอะไรถูกเก็บ · ผิดพลาด = ติดต่อเครื่องไม่ได้ หรือเครื่องปฏิเสธคำขอ ทั้ง ไม่มีข้อมูล และ ผิดพลาด นับรวมเป็นจำนวนข้อผิดพลาดของงานนี้",
    log_no_data_note:
      "มีหมายเลขที่เครื่องตอบว่าสำเร็จ แต่ไม่ได้ส่งข้อมูลข้อความเสียงกลับมา หมายเลขเหล่านี้ไม่ได้ถูกเก็บลงไฟล์สำรอง และนี่ไม่ใช่กล่องข้อความว่าง กรุณาตรวจสอบว่าหมายเลขเหล่านี้มีอยู่จริงบนเครื่องและอยู่บน EAS Server ที่ถูกต้อง ก่อนสั่งย้าย EAS Server ซึ่งจะลบข้อความเสียงต้นทางทิ้งถาวร",
    log_count_read: "อ่านสำเร็จ",
    log_count_incomplete: "ไม่สมบูรณ์",

    // สองความหมายของ errors.voicemailbackup.partial
    // ฝั่งสำรองคือ "อ่านไม่สำเร็จ" ฝั่งกู้คืนคือ "เขียนรวมไม่สำเร็จ"
    // ซึ่งมีสาเหตุเฉพาะของตัวเอง เช่น เครื่องปฏิเสธหมายเลข ข้อความไม่มีไฟล์เสียง
    // หรือรวมแล้วไม่มีข้อความใดถูกเพิ่ม
    partial_backup: "มีบางหมายเลขที่ไม่ได้ถูกเก็บลงไฟล์สำรอง ไฟล์สำรองจึงไม่ครบ",
    partial_restore:
      "มีบางหมายเลขที่รวมข้อความกลับเข้ากล่องไม่สำเร็จ อาจเพราะเครื่องปฏิเสธหมายเลขนั้น ข้อความไม่มีไฟล์เสียง หรือไม่มีข้อความใดถูกเพิ่ม",
    log_failed: "ดึงผลรายหมายเลขไม่สำเร็จ",
    list_failed: "ดึงรายการงานสำรอง/กู้คืนไม่สำเร็จ",
    download_failed: "ดาวน์โหลดไฟล์สำรองไม่สำเร็จ",

    // การกู้คืนเป็นการ "รวม" (merge) ไม่ใช่การเขียนทับ
    // ข้อความที่เข้ามาใหม่หลังสำรองยังอยู่ครบ ข้อความที่มีอยู่แล้วไม่ถูกเพิ่มซ้ำ
    // และกดซ้ำอีกครั้งก็ไม่เปลี่ยนอะไร ถ้าเขียนว่าเขียนทับหรือย้อนกลับไม่ได้
    // ผู้ปฏิบัติงานจะไม่กล้ากู้คืนเข้ากล่องที่ใช้งานอยู่ ซึ่งเป็นกรณีที่ merge
    // ถูกออกแบบมาเพื่อรองรับโดยตรง แต่ยังคงระบุชื่อองค์กรและวันที่สำรองไว้
    // เพราะแถวในหน้านี้ต่างกันแค่สองอย่างนี้
    restore_confirm_title: "ยืนยันการกู้คืนข้อความเสียง?",
    restore_confirm_text:
      "ระบบจะนำข้อความเสียงจากไฟล์สำรองขององค์กร {corporate} (สำรองเมื่อ {created}) รวมกลับเข้ากล่องข้อความของหมายเลขเหล่านั้น ข้อความที่เข้ามาใหม่หลังจากวันที่สำรองจะยังอยู่ครบ และข้อความที่มีอยู่แล้วจะไม่ถูกเพิ่มซ้ำ ระบบจะเพิ่มเฉพาะข้อความที่ขาดหายไปเท่านั้น ดังนั้นกดซ้ำอีกครั้งก็ไม่เปลี่ยนแปลงอะไร กรุณาตรวจสอบชื่อองค์กรให้ถูกต้องก่อนยืนยัน",
    restore_confirm_yes: "ใช่, กู้คืน",

    restore_title: "กู้คืนข้อความเสียง",
    restore_step_extract: "แตกไฟล์",
    restore_step_extract_hint: "อ่านไฟล์ ZIP ที่สำรองไว้",
    restore_step_restore: "รวมข้อความ",
    restore_step_restore_hint: "ทีละหมายเลข",
    restore_step_done: "เสร็จสิ้น",
    restore_step_done_hint: "ข้อความกลับเข้ากล่องแล้ว",
    restore_progress_label: "ความคืบหน้า",
    restore_current_number: "กำลังรวมหมายเลข",
    restore_current_none: "กำลังเตรียมข้อมูล...",
    restore_elapsed: "เวลาที่ใช้",
    restore_done_text:
      "กู้คืนเรียบร้อยแล้วครบทุกหมายเลข ระบบรวมข้อความจากไฟล์สำรองกลับเข้ากล่องแล้ว โดยข้อความที่มีอยู่เดิมยังอยู่ครบ",
    // กู้คืนเสร็จแต่ไม่ครบ ต้องบอกให้ชัด ไม่ให้เข้าใจว่าองค์กรนี้ข้อมูลครบแล้ว
    restore_partial:
      "กู้คืนเสร็จแล้ว แต่มีบางหมายเลขที่รวมข้อความกลับไม่สำเร็จ อาจเพราะเครื่องปฏิเสธหมายเลขนั้น หรือข้อความไม่มีไฟล์เสียง ข้อความที่อยู่ในกล่องเดิมไม่ได้หายไป แต่ไฟล์สำรองนี้ยังกู้คืนได้ไม่ครบ กรุณาดูผลรายหมายเลขเพื่อตรวจสอบว่าหมายเลขใด แล้วสั่งกู้คืนซ้ำได้ทันที เพราะการกู้คืนซ้ำจะไม่ทำให้ข้อความซ้ำกัน",
    restore_error_title: "กู้คืนข้อความเสียงไม่สำเร็จ",
    restore_error_log_title: "รายละเอียดจากระบบเบื้องหลัง",
    restore_failed: "กู้คืนข้อความเสียงไม่สำเร็จ",
    restore_no_job_id:
      "ระบบไม่ได้ส่งรหัสงานกู้คืนกลับมา จึงไม่สามารถติดตามสถานะได้ กรุณาตรวจสอบรายการในตารางแล้วลองใหม่อีกครั้ง",
    restore_worker_stopped:
      "ระบบเบื้องหลังที่ทำงานกู้คืนนี้หยุดทำงานก่อนเสร็จ กรุณาดูผลรายหมายเลขเพื่อตรวจสอบว่ารวมข้อความสำเร็จถึงหมายเลขใด หมายเลขที่รวมไปแล้วไม่ได้รับผลกระทบ และการสั่งกู้คืนซ้ำจะเพิ่มเฉพาะส่วนที่ยังขาดเท่านั้น",
    restore_see_log:
      "กดปุ่มดูผลรายหมายเลขที่แถวของงานกู้คืนนี้ เพื่อดูผลของแต่ละหมายเลข"
  },

  voicemailbackup: {
    started: "ระบบรับรายการสำรองข้อความเสียงเข้าคิวแล้ว",
    restore_started: "ระบบรับรายการกู้คืนข้อความเสียงเข้าคิวแล้ว",
    success: "สำเร็จ"
  },
  export: {
    button: "ส่งออก",
    processing: "กำลังประมวลผล",
    processing_text: "กำลังสร้างไฟล์ Excel โปรดรอสักครู่...",
    failed: "ส่งออกล้มเหลว",
    error_title: "เกิดข้อผิดพลาดในการส่งออก"
  },
  "errors.eventlog.range_over_one_day": "ช่วงวันที่ต้องไม่เกิน 2 วัน",
  // คีย์ errors.db.* ต้องเขียนแบบแบน (ทั้งคีย์อยู่ในเครื่องหมายคำพูด) ที่ระดับบนสุด
  // เพราะ backend ส่งทั้ง "errors.db.query" และ "errors.db.query.failed"
  // ถ้าเขียนเป็นโครงสร้างซ้อนกัน errors.db.query จะต้องเป็นทั้งข้อความและ object
  // พร้อมกัน ซึ่งเป็นไปไม่ได้ vue-i18n จะหาตาม path ก่อน ไม่พบ errors.db
  // แล้วจึงถอยมาหาคีย์แบนที่ระดับบนสุด (ดู VueI18n.prototype._interpolate)
  "errors.db.query": "เชื่อมต่อฐานข้อมูลผิดพลาด",
  "errors.db.query.failed": "เชื่อมต่อฐานข้อมูลผิดพลาด",
  logs: {
    title: "Event Logs",
    range: "ช่วงเวลา",
    range_last_1h: "1 ชั่วโมงล่าสุด",
    range_last_2h: "2 ชั่วโมงล่าสุด",
    range_last_12h: "12 ชั่วโมงล่าสุด",
    range_last_24h: "24 ชั่วโมงล่าสุด",
    range_custom: "กำหนดเอง",
    start_date: "วัน/เวลาเริ่ม",
    end_date: "วัน/เวลาสิ้นสุด",
    session_id: "Session ID",
    session_id_placeholder: "ค้นหาด้วย session id (จับคู่บางส่วน)",
    search: "ค้นหา",
    user: "ผู้ใช้",
    user_id: "ผู้ใช้",
    route: "Route",
    start_at: "เริ่มเมื่อ",
    events: "Event",
    errors: "ข้อผิดพลาด",
    actions: "การจัดการ",
    view: "ดู",
    timeline: "ลำดับเหตุการณ์",
    no_events: "ไม่มีเหตุการณ์สำหรับ session นี้",
    copy_detail: "คัดลอกรายละเอียด",
    view_xml: "ดู XML",
    xml_title: "SOAP XML",
    copy_xml: "คัดลอก XML"
  },
  bc_logs: "Event Logs",
  bc_migration: "Migration Tools",
  bc_easmigration: "ย้าย EAS Server",
  bc_voicemaillog: "สำรอง/กู้คืนข้อความเสียง",
  migration: {
    title: "Migration Tools",
    clear_title: "ล้างข้อมูลเบอร์",
    clear_help: "ระบบจะ ShPull เบอร์จาก MetaSwitch แล้วเคลียร์ Subscriber + NumberBlock + WCI ให้ทั้งหมด ใส่แค่หมายเลขโทรศัพท์ — Business Group / CFS / EAS อ่านจาก subscriber record อัตโนมัติ",
    number: "หมายเลขโทรศัพท์",
    clear_button: "ล้าง",
    confirm_title: "ยืนยันการล้าง?",
    confirm_text: "ระบบจะลบ {number} ออกจาก WCI + MetaSwitch แบบถาวร",
    confirm_yes: "ใช่, ล้าง",
    running: "กำลังประมวลผล",
    running_text: "กำลังเรียก WCI และ MetaSwitch...",
    result: "ผลลัพธ์",
    overall_ok: "สำเร็จทั้งหมด",
    overall_partial: "สำเร็จบางส่วน",
    col_step: "ขั้นตอน",
    col_status: "สถานะ",
    col_code: "Code",
    col_detail: "รายละเอียด",
    failed: "ล้างไม่สำเร็จ"
  },
  maintenance: {
    title: "ระบบอยู่ระหว่างปรับปรุง",
    description: "ขออภัยในความไม่สะดวก ระบบจะกลับมาให้บริการเร็วๆ นี้"
  },
  auth: {
    signin: "เข้าสู่ระบบ",
    signout: "ออกจากระบบ",
    username: "อีเมล์หรือหมายเลขผู้ใช้งาน",
    email: "อีเมล์",
    pass: "รหัสผ่าน",
    forgetpass: "ลืมรหัสผ่าน",
    resetpass: "รีเซ็ตพาสเวิร์ด",
    confirm_reset_pass: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
    forgot_pass_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
    reset_pass_success: "เปลี่ยนรหัสผ่านสำเร็จ",

    twofa: "ยืนยันรหัส OTP",
    twofa_send_to: "รหัส OTP ของคุณถูกส่งไปยังหมายเลข {0}",
    otp_ref_code: "(รหัสอ้างอิง OTP : {0})",
    refcode: "รหัสอ้างอิง",
    otpcode: "รหัส OTP",
    requestotp: "ขอรหัส OTP",
    requestnewotp: "ขอรหัส OTP ใหม่ใน {0} วินาที"
  },
  corp: {
    name: "ชื่อองค์กร",
    brn: "BRN",
    code: "หมายเลของค์กร",
    create: "สร้างองค์กร",
    create_success: "สร้างองค์กรสำเร็จ",
    create_fail: "สร้างองค์กรไม่สำเร็จ"
  },
  package: {
    name: "ชื่อแพ็คเกจ",
    code: "หมายเลขแพ็คเกจ",
    create: "สร้างแพ็คเกจ",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "สร้างแพ็คเกจสำเร็จ",
    create_fail: "สร้างแพ็คเกจไม่สำเร็จ"
  },
  number: {
    add: "เพิ่มหมายเลข",
    type: "ประเภทหมายเลข",
    pilot: "หมายเลของค์กร",
    agent: "หมายเลขผู้ใช้งาน",
    charge: "หมายเลขที่คิดค่าใช้จ่าย",
    syncpackage: "ตรวจสอบแพ็คเกจ",
    create_success: "สร้างหมายเลขสำเร็จ",
    agent_create: "สร้างหมายเลขผู้ใช้งาน",
    pilot_create: "สร้างหมายเลของค์กร",
    pilot_create_success: "สร้างเบอร์องค์กรสำเร็จ",
    pilot_create_fail: "สร้างเบอร์องค์กรไม่สำเร็จ",
    agent_create_success: "สร้างเบอร์ผู้ใช้งานสำเร็จ",
    agent_create_fail: "สร้างเบอร์ผู้ใช้งานไม่สำเร็จ",
    bgadmin_login_fail: "ไม่สามารถเข้าสู่ระบบการตั้งค่าได้",
    comportal_login_fail: "ไม่สามารถเข้าสู่ระบบ Com Portal",
    sync_package_success: "ซิงค์ข้อมูลแพ็คเกจสำเร็จ",
    alternative: "Alternative",
    main_ivr: "Main IVR",
    real: "Real",
    additional: "Additional",
    mapping: "Mapping Number"
  },
  voicemail: {
    name: "ข้อความเสียง",
    called: "ถึง",
    caller: "จาก",
    date: "วันที่",
    corp: "องค์กร"
  },
  report: {
    chart_answer: "จำนวยสายที่รับ (คร้ง)",
    chart_abandon: "จำนวนสายที่ไม่ได้รับ (ครั้ง)",
    chart_talk_time_avg: "เวลาเฉลี่ยในการสนทนา (นาที)",
    chart_talk_time: "เวลาการสนทนารายวัน (นาที)",
    unit_call: " (ครั้ง)",
    unit_min: " (นาที)",

    inbound_answer: "จำนวนสายเรียกเข้าที่รับสาย",
    inbound_abandon: "จำนวนสายที่ไม่ได้รับ",
    inbound_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    inbound_talk_time: "เวลาการสนทนารายวัน",

    outbound_answer: "จำนวนสายโทรออกที่ถูกรับ",
    outbound_abandon: "จำนวนสายที่ไม่ได้รับ",
    outbound_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    outbound_talk_time: "เวลาการสนทนารายวัน",

    internal_answer: "จำนวนสายภายในที่ถูกรับสาย",
    internal_abandon: "จำนวนสายภายในที่ไม่ได้รับ",
    internal_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    internal_talk_time: "เวลาการสนทนารายวัน",

    menu: "ข้อมูลการโทร",
    charging_group: "Charging Group",
    export: "ส่งออก",
    enterprise_number: "เบอร์องค์กร",
    number: "หมายเลข",
    enterprise: "ชื่อองค์กร",
    enterprise_sub: "สาขาย่อย",
    type: "ประเภท",
    cdr_report: "รายงานการใช้งานโทรศัพท์",
    dashboard_report: "รายงานสรุปภาพรวมการใช้งาน",
    performance_report_type: "ประเภทของรายงาน",
    performance_by_number: "ข้อมูลระดับผู้ใช้งาน",
    performance_by_group: "ข้อมูลระดับองค์กร",
    date: "วันที่",
    start: "วันที่เริ่มต้น",
    end: "วันที่สิ้นสุด",
    search: "ค้นหา",
    call_type: "ประเภทการโทร",
    outbound: "สายโทรออก",
    inbound: "สายโทรเข้า",
    internal: "สายที่โทรภายใน",
    voicemail: "ข้อความเสียง",
    all: "ทั้งหมด",
    call_status: "สถานะการโทร",
    status_answered: "รับสาย",
    status_no_answer: "ไม่ได้รับสาย",
    corporate: "องค์กร",
    call_dates: "วันที่",
    call_origination: "เบอร์ต้นทาง",
    display_number: "เบอร์ที่แสดง",
    call_termination: "เบอร์ปลายทาง",
    start_time: "เวลาที่เริ่ม",
    ringing: "ระยะเวลารอสาย (วินาที)",
    answered_time: "ระยะเวลารับสาย",
    terminated_time: "เวลาที่จบการสนทนา",
    terminated_reason: "เหตูผลที่จบการสนทนา",
    reason_change: "สาเหตุของการเปลี่ยนเบอร์สนทนา",
    final_number: "เบอร์ปลายทางที่ถูกโอนสายมา",
    duration: "ระยะเวลา (วินาที)",
    total_call: "จำนวน Transaction Log ทั้งหมด",
    answered: "จำนวนสายสนทนา (โทรออกและรับสาย) ทั้งหมด",
    unanswered:
      "จำนวนสายที่ไม่ได้รับทั้งหมดของสายเรียกเข้า, สายโทรออก และสายถึง Call Hunting Group",
    longest_waiting_time: "ระยะเวลารอสายที่นานที่สุด (รวมสายโทรออกและรับสาย)",
    avg_waiting_time: "ระยะเวลาเฉลี่ยที่เจ้าหน้าที่รอสาย (วินาที)",
    avg_talk_time: "ค่าเฉลี่ยระยะเวลาสนทนาทั้งหมด (วินาที)",
    call_volume: "จำนวน Transaction Log ต่อวัน",
    number_of_calls: "จำนวนการโทรออกและการรับสาย (สาย)",
    talk_time: "ระยะเวลาสนทนารวมเชื่อมต่อ dtac OneCall ทั้งหมด",
    idle_time: "ระยะเวลาที่ว่างจากการสนทนา",
    speed_of_answer: "ความเร็วในการรับสาย (วินาที)",
    status: "สถานะ",
    // date_warning: "ไม่สามารถค้นหาข้อมูลได้เกิน 60 วัน และถ้าค้นหาข้อมูลมากกว่า 30 วันการค้นหาอาจจะเกิดความล่าช้า", 18_feb_2022
    // data_start : "ค้นหาข้อมูลย้อนหลังได้ถึง 60 วัน",
    date_warning:
      "ค้นหาข้อมูลย้อนหลังได้ถึง 90 วัน คำแนะนำเพื่อการแสดงผลที่รวดเร็ว ควรค้นหาข้อมูลไม่เกิน 30 วัน",
    data_start: "ระบบจะแสดงข้อมูลตั้งแต่วันที่ 25 กุมภาพันธ์ 2022 เป็นต้นไป",
    call_voicemail: "ข้อความเสียง (สาย)",
    no_number: "No Caller ID"
  },
  user: {
    create: "สร้างผู้ใช้งาน",
    name: "ชื่อ",
    username: "ชื่อผู้ใช้",
    phone: "เบอร์โทรศัพท์",
    role: "ระดับผู้ใช้งาน",
    type: "ประเภทผู้ใช้งาน",
    create_success: "สร้างผู้ใช้งานสำเร็จ",
    create_fail: "สร้างผู้ใช้งานไม่สำเร็จ"
  },
  mlhg: {
    name: "กลุ่ม Hunt",
    failed: "กลุ่ม Hunt ล้มเหลว",
    success: "กลุ่ม Hunt สำเร็จ",
    pilot_number: "หมายเลขนำหมู่",
    pilot_number_type: "ประเภทหมายเลขนำหมู่",
    pilot_number_dummy: "Dummy Number",
    pilot_number_real: "Real Number"
  },

  corporate_main: "องค์กรหลัก",
  group_name: "ชื่อกลุ่ม",
  email: "อีเมล์",
  email_optional: "อีเมล์ (ไม่ระบุ)",
  created: "วันที่สร้าง",
  save: "บันทึก",
  back: "กลับ",
  new: "สร้าง",
  status: "สถานะ",
  download: "ดาวน์โหลด",
  downloadall: "ดาวน์โหลดทั้งหมด",
  search: "ค้นหา",
  welcome: "ยินดีต้อนรับ",
  myprofile: "ข้อมูลส่วนตัว",
  changepass: "เปลี่ยนรหัสผ่าน",
  page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
  page_notfound_desc:
    "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
  actions: "เมนู",
  data: "ข้อมูล",
  to: "ถึง",
  of: "จาก",
  row_select: "ข้อมูลที่ถูกเลือก",
  yes: "ใช่",
  no: "ไม่ใช่",
  ok: "ตกลง",
  cancel: "ยกเลิก",
  upload_file: "เพิ่มไฟล์",
  upload: "อัพโหลด",
  upload_number_success: "อัพโหลดหมายเลขผู้ใช้งานสำเร็จ",
  bg_admin: "ตั้งค่าผู้ดูแลระบบ",
  comportal: "ตั้งค่าผู้ใช้งาน",
  add: "เพิ่ม",
  import: "นำเข้า",
  clear: "ลบประวัติการนำเข้า",
  close: "ปิด",
  please_select: "กรุณาเลือก",
  create: "สร้าง",
  confirm: "ยืนยัน",
  create_success: "สร้างข้อมูลสำเร็จ",
  delete_confirm: "ยืนยันการลบข้อมูล",
  delete_confirm_text: "คุณต้องการลบข้อมูล ",
  delete_confirm_question: "คุณต้องการลบข้อมูล ",
  delete_success: "ลบข้อมูลสำเร็จ",
  delete_fail: "ลบข้อมูลไม่สำเร็จ",
  edit_success: "แก้ไขข้อมูลสำเร็จ",
  edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
  edit: "แก้ไข",
  delete: "ลบ",
  import_inprogress: "กำลังประมวลผล กรุณาตรวจสอบสถานะ",
  processing: "กำลังประมวลผล กรุณารอสักครู่"
};
